export default __webpack_public_path__ + "static/media/wlogo.f9728fd8.svg";